// src/pages/CustomMaterialThanks.js  —  route: /custom-material/thanks
// Stripe sends the teacher here after paying $29 for a custom material
// request. We confirm with the server (which marks the request paid once —
// the webhook may already have), clear the saved draft, and send them back.

import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { auth, functions } from "../firebase/firebaseConfig";
import { clearCustomDraft } from "../components/customMaterial/CustomMaterialForm";

export default function CustomMaterialThanks() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ status: "working" });
  const rawBack = params.get("back") || "/educator/dashboard";
  const back = rawBack.startsWith("/") ? rawBack : "/educator/dashboard";

  useEffect(() => {
    const sessionId = params.get("session_id");
    const confirm = httpsCallable(functions, "confirmCustomMaterial");
    const stop = onAuthStateChanged(auth, async (user) => {
      if (!user) return navigate("/login", { replace: true });
      if (!sessionId) return setState({ status: "missing" });
      for (let i = 0; i < 6; i += 1) {
        try {
          // eslint-disable-next-line no-await-in-loop
          const { data } = await confirm({ sessionId });
          if (data?.status === "paid") {
            clearCustomDraft();
            setState({ status: "done", ...data });
            return undefined;
          }
        } catch (e) {
          setState({ status: "error", message: e?.message });
          return undefined;
        }
        // eslint-disable-next-line no-await-in-loop
        await new Promise((r) => setTimeout(r, 1500));
      }
      setState({ status: "pending" });
      return undefined;
    });
    return () => stop();
  }, [params, navigate]);

  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#fff7ed", fontFamily: '"Baloo 2", "Fredoka", sans-serif', padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 24, padding: "28px 32px", textAlign: "center", maxWidth: 500, boxShadow: "0 18px 40px rgba(0,0,0,0.15)", border: "4px solid #fdba74" }}>
        {state.status === "working" && <h2>Confirming your request…</h2>}
        {state.status === "done" && (
          <>
            <div style={{ fontSize: 46 }} aria-hidden="true">🎶</div>
            <h2 style={{ margin: 0 }}>Thank you — your request is in!</h2>
            <p style={{ fontSize: 17, lineHeight: 1.5 }}>
              {state.topic ? <>We've got your facts for <b>{state.topic}</b>. </> : null}
              We'll write your song and game and email you when it's ready.
            </p>
          </>
        )}
        {state.status === "pending" && <p>Your payment is still being confirmed. Your request is saved and will be marked paid in a minute or two.</p>}
        {state.status === "missing" && <p>We couldn't find that request.</p>}
        {state.status === "error" && <p>Something went wrong: {state.message}. If you were charged, your request is still saved — or contact us.</p>}
        <button type="button" onClick={() => navigate(back, { replace: true })} style={{ marginTop: 14, border: 0, borderRadius: 12, padding: "10px 22px", background: "#f97316", color: "#fff", fontWeight: 900, fontSize: 17, cursor: "pointer" }}>
          Back to my portal
        </button>
      </div>
    </div>
  );
}
